import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { LuPlus } from "react-icons/lu";
import callOpenAIAPI, { callOpenAIAPIRisks  } from "../utils/openAI.js";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useDrag } from 'react-dnd';
import { useDrop } from 'react-dnd';
import {aiRiskDrop, editRisk ,editControl, editAction, createRisk, resetError, getRisks, openOverlay, closeOverlay, getDepartments, resetSortedTriggered, resetNewlycreatedRiskId, resetAllTableDefinitions, setCurrentPageRedux, resetChangedPageSize, setPageSizeRedux } from "../store/actions/riskActions";

import { Redirect } from 'react-router-dom';
import { BsStars } from "react-icons/bs";


import LOADER from "../assets/images/loader.svg";


import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';



import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";

import RiskDetailsForm from "../components/Risk/RiskOverlay";
import DraggableControlCard from "../components/Risk/DraggableControlCard.js";
import DraggableRiskCard from "../components/Risk/DraggableRiskCard.js";
import IncidentDetailsForm from "../components/Incidents/IncidentOverlay";
import ControlOverlay from "../components/Control/ControlOverlay";
import ActionOverlay from "../components/Action/ActionOverlay";

import RiskTable from "../components/Risk/RiskTable";



import { useHistory } from "react-router-dom";


import Select from 'react-select'

import { NotificationContainer } from 'react-notifications';

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#3b3b3b' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #3b3b3b' : 'none',
        '&:hover': {
            borderColor: '#3b3b3b',
        },
        backgroundColor: '#EEF0ED',
        padding: 1,
        width: '220px',
        marginLeft: '10px',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 999999999999, // Ensures the menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#3b3b3b' : state.isFocused ? '#EEF0ED' : 'white',
        color: state.isSelected ? 'white' : '#3b3b3b',
        '&:hover': {
            // backgroundColor: '#EEF0ED',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),
};




function Risk(props) {

    const {departmentID, aiRiskDropFN, departmentName, departmentDef, editRiskFN, editControlFN, editActionFN, token, error, risks, createRiskFN, resetErrorFN, getRisksFN, openOverlayFN, isOverlayOpen, closeOverlayFN, totalPages, currentPage, pageSize, gotoIncident, go_to_risk_dashboard, go_to_bowtie, departments, getDepartmentsFN, sortBy, sorted_triggered, resetSortedTriggeredFN, activeDepartmentId, activeDepartment, newlycreatedRiskId, resetNewlycreatedRiskIdFN, profile, setCurrentPageReduxFN, resetChangedPageSizeFN, changed_page_size, setPageSizeReduxFN, riskType, match, activeriskforworkflow, setActiveRiskForWorkflow, id } = props;

    const history = useHistory();

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isIncidentOpen, setIsIncidentOpen] = useState(false);
    const [isControlOpen, setIsControlOpen] = useState(false);
    const [control_id, setControlId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [risk_id, setRiskId] = useState(null);
    const [isActionOpen, setIsActionOpen] = useState(false);
    const [action_id, setActionId] = useState(null);

    const [selectedDepartment, setSelectedDepartment] = useState(activeDepartmentId ? { value: activeDepartmentId, label: activeDepartment } : null);


    const currentDeptId =
        activeDepartmentId ?? selectedDepartment?.value ?? profile?.department_id ?? null;
    //console.log("activeDepartmentId",activeDepartmentId)
    const departmentOptions = departments && departments.map(department => ({
        value: department.department_id,
        label: department.name
    }));

    const deptRef = React.useRef(currentDeptId);
    useEffect(() => {
        deptRef.current = currentDeptId;
    }, [currentDeptId]);

    // useEffect(() => {
    //     if (match.params.view_risk) {

    //         //check if risk_id is in the risks array
    //         const risk = risks.find(risko => parseInt(risko.ID) === parseInt(match.params.view_risk));
    //         if (risk) {
    //             history.push({ pathname: `/risk` });
    //             setRiskId(risk.ID);
    //             setIsPopupOpen(true);
    //         }
    //         else {
    //             history.push({ pathname: `/risk` });
    //         }

    //         // remove from url

    //     }
    // }, [risks]);

    const { view_risk } = useParams(); // Extract view_risk from URL parameters

    useEffect(() => {
        if (view_risk) {
            // Check if risk_id is in the risks array
            const risk = risks.find(risko => parseInt(risko.ID) === parseInt(view_risk));
            //console.log("Redirect Test", risk)
            if (risk) {
                history.push({ pathname: `/risk` });
                setRiskId(risk.ID);
                setIsPopupOpen(true);
                openOverlayFN(risk.ID)
                //getRisksFN(1, 1, )
            } else {
                history.push({ pathname: `/risk` });
            }
        }
    }, [risks, view_risk]);

    useEffect(() => {
        if (go_to_risk_dashboard) {
            history.push({ pathname: `/dashboards/${go_to_risk_dashboard}` });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [go_to_risk_dashboard]);

    useEffect(() => {
        if (go_to_bowtie) {
            history.push({ pathname: `/bowtie/${go_to_bowtie}` });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [go_to_bowtie]);

    useEffect(() => {
        if (gotoIncident) {
            // setIsIncidentOpen(true);
            history.push({ pathname: `/incidents/${gotoIncident}` });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gotoIncident]);

    useEffect(() => {
        console.log("isOverlayOpen", isOverlayOpen, ": " ,id)
        if (isOverlayOpen && id) {
            setRiskId(id);
            setIsPopupOpen(true);
        }
    }, [isOverlayOpen, id]);

    /*
    useEffect(() => {
        //?  resetErrorFN();
        //////console.log(sortBy);
        getDepartmentsFN();
        ////console.log("getting risks 1");
        getRisksFN(currentPage, pageSize, selectedDepartment, sortBy);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, pageSize]);


    useEffect(() => {
        if (sortBy) {
            //////console.log(currentPage, pageSize, selectedDepartment, sortBy);
            ////console.log("getting risks 2");
            getRisksFN(currentPage, pageSize, selectedDepartment && selectedDepartment.value ? selectedDepartment.value : null, sortBy);

        }
    }, [sortBy]);

    */

    useEffect(() => {
        if (newlycreatedRiskId) {
            ////console.log("newlycreatedRiskId", newlycreatedRiskId);
            resetNewlycreatedRiskIdFN();
            setRiskId(newlycreatedRiskId);
            setIsPopupOpen(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newlycreatedRiskId]);

    useEffect(() => {

        if (selectedDepartment) {
            if (activeDepartmentId !== selectedDepartment.value) {
                setSelectedDepartment(activeDepartmentId ? { value: activeDepartmentId, label: activeDepartment } : null);
                setCurrentPageReduxFN(1);
                resetSortedTriggeredFN();
                ////console.log("sortBy was changed", sorted_triggered);
                if (profile && (profile.role === "Admin" || profile.role === "Auditor")) {
                    getRisksFN(1, pageSize, activeDepartmentId, sortBy);
                }
                else {
                    getRisksFN(1, pageSize, profile.department_id, sortBy);
                }
            }
        }
        console.log("selectedDepartment", activeDepartmentId)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeDepartmentId]);


    useEffect(() => {
        if (changed_page_size) {
            resetChangedPageSizeFN();
            setCurrentPageReduxFN(1);


            if (profile && (profile.role === "Admin" || profile.role === "Auditor")) {
                getRisksFN(1, pageSize, selectedDepartment && selectedDepartment.value ? selectedDepartment.value : null, sortBy);
            }
            else {
                getRisksFN(1, pageSize, profile.department_id, sortBy);
            }



        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [changed_page_size]);

    useEffect(() => {
        //console.log('sorted triggered"');
        if (sorted_triggered) {
            resetSortedTriggeredFN();
            ////console.log("sortBy was changed 2", sorted_triggered);
            if (profile && (profile.role === "Admin" || profile.role === "Auditor")) {
                getRisksFN(currentPage, pageSize, selectedDepartment && selectedDepartment.value ? selectedDepartment.value : null, sortBy);
            }
            else {
                getRisksFN(currentPage, pageSize, profile.department_id, sortBy);
            }


        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sorted_triggered]);


    useEffect(() => {
        //resetAllTableDefinitionsFN();
        setPageSizeReduxFN(10);

        getDepartmentsFN();
        // getRisksFN(1, 5, selectedDepartment && selectedDepartment.value ? selectedDepartment.value : null, sortBy);
        if (profile && (profile.role === "Admin" || profile.role === "Auditor")) {
            getRisksFN(1, 10, selectedDepartment && selectedDepartment.value ? selectedDepartment.value : null, sortBy);
        }
        else {
            getRisksFN(1, 10, profile.department_id, sortBy);
        }
        ////console.log("getting risks 1");

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (error) {
            setLoading(false);
            //resetErrorFN();
        }
    }, [error]);

    useEffect(() => {

        setLoading(false);
        resetErrorFN();

        if (risks) {
            //console.log("data:", risks);
            setData(risks);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [risks]);



    //console.log("risk data", data);
    const closeCreation = async (data, risk_id) => {

        ////console.log("getting risks 3");

        setControls([]);

        //getRisksFN(currentPage, pageSize);
        if (profile && (profile.role === "Admin" || profile.role === "Auditor")) {
            getRisksFN(currentPage, pageSize, selectedDepartment && selectedDepartment.value ? selectedDepartment.value : null, sortBy);
        }
        else {
            getRisksFN(currentPage, pageSize, profile.department_id, sortBy);
        }
        
        await updateRiskServerData(data, risk_id)
        await closeOverlayFN();
        ////console.log("closeCreation")
        setIsPopupOpen(false);

    }


    const closeIncident = () => {
        ////console.log("closeIncident")
        setIsIncidentOpen(false);

    }

    // State to store AI-suggested controls
    const [controls, setControls] = useState([]);
    const [loadingAI, setLoadingAI] = useState(false); // For loading state during API call
    const [showControls, setShowControls] = useState(false); // Tracks when to show controls with animation

    const onRemoveControl = (id) => {
        setControls(prevControls => prevControls.filter(c => c.id !== id));
    };

    const fetchAISuggestions = async (title, details, threats) => {
        setShowControls(false);
        setLoadingAI(true); // Show loading indicator
        ////console.log("loadingAI set to true");
        try {
            // Call the backend API for the `suggestControl` use case
            const aiResponse = await callOpenAIAPI( title, details, threats);
            console.log("aiResponse1",aiResponse)
            const parsedControls = aiResponse.map((control, i) => ({
                ...control,
                id: crypto.randomUUID?.() || `control-${i}`,
            }));
            setControls(parsedControls);

            console.log("aiResponse",parsedControls)
            // Introduce a delay before showing controls
            setTimeout(() => {
                setShowControls(true); // Trigger animation
            }, 300); // 300ms delay for animation

        } catch (error) {
            console.error("Error fetching AI suggestions:", error);
        } finally {
            setLoadingAI(false); // Hide loading indicator
            ////console.log("loadingAI set to false");
            ////console.log("AI CONTROLS: ", controls);
        }
    };




    const closeControl = async(data, control_id) => {
        console.log("closeControl")
        setIsControlOpen(false);
        await updateControlServerData(data, control_id)
    }


    const closeAction = async (data, action_id) => {
        ////console.log("closeAction")
        setIsActionOpen(false);
        await updateActionServerData(data, action_id)

    }
    ////console.log("Type of setControlId:", typeof setControlId);

    ////console.log("risk table data: ", data);

    const updateRiskServerData = async (data, risk_id) => {
        console.log("Update data", data)
        setLoading(true);
        await editRiskFN(risk_id, data);
        setLoading(false);
    }


    const updateControlServerData = async (data, control_id) => {

        const updatedData = { ...data };

            // Add one day to StartDate and EndDate if they exist
            if (updatedData.StartDate) {
                const startDate = new Date(updatedData.StartDate);
                startDate.setDate(startDate.getDate() + 1);
                updatedData.StartDate = startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
            }

            if (updatedData.EndDate) {
                const endDate = new Date(updatedData.EndDate);
                endDate.setDate(endDate.getDate() + 1);
                updatedData.EndDate = endDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
            }

            console.log("CONTROL DATA AFTER ADJUSTMENT", updatedData);

            setLoading(true);
            await editControlFN(risk_id, control_id, updatedData);
            setLoading(false);
    }
    const [{ isOver }, dropRef] = useDrop(
        () => ({
            accept: 'RISK',
            drop: (item) => {
                const droppedRisk = item.control;
                const deptId = deptRef.current;  // ALWAYS the latest
                handleDrop(droppedRisk, deptId);
            },
            collect: (monitor) => ({ isOver: !!monitor.isOver() }),
        }),
        [currentDeptId] // <— important
    );

    const handleDrop = async (droppedRisk, deptId) => {
        console.log("Risk received in handleDrop:", droppedRisk);
        //console.log("Riks state", formState)
        // Prepare the control data
        const riskData = {
            RiskID: droppedRisk.ControlID,
            RiskDetails: droppedRisk.definition,  // Control details from the dropped control
            RiskTitle: droppedRisk.title || '',
            Threats: droppedRisk.threats || [],
            owner: profile.user_id || null
        };

        console.log("Risk Data", riskData)
        // **Optimistic UI update**: Immediately update the frontend with the dropped control
        // setFormControlState(prevState => [
        //     ...prevState,
        //     controlData  // Add the dropped control to the state immediately
        // ]);
        // Call the API
        console.log("DROP → dept", { activeDepartmentId, selectedDepartment, deptId, droppedRisk });
        aiRiskDropFN(riskData, deptId);
    };

    const [AIRisks, setAIRisks] = useState([]);
    const [loadingAIRisk, setLoadingAIRisk] = useState(false); // For loading state during API call
    const [showRisks, setshowRisks] = useState(false); // Tracks when to show controls with animation

     const onRemoveRisk= (id) => {
        setAIRisks(prevControls => prevControls.filter(c => c.id !== id));
    };

    const handleAISuggestions = async () =>{

        console.log(departmentDef, "  ", departmentName)

        setshowRisks(false);
        setLoadingAIRisk(true); // Show loading indicator
        ////console.log("loadingAI set to true");
        try {
            // Call the backend API for the `suggestControl` use case
            const aiResponse = await callOpenAIAPIRisks( departmentName, departmentDef );
            console.log("aiResponse1",aiResponse)
            const parsedControls = aiResponse.map((control, i) => ({
                ...control,
                id: crypto.randomUUID?.() || `control-${i}`,
            }));
            setAIRisks(parsedControls);

            console.log("aiResponse",parsedControls)
            // Introduce a delay before showing controls
            setTimeout(() => {
                setshowRisks(true); // Trigger animation
            }, 300); // 300ms delay for animation

        } catch (error) {
            console.error("Error fetching AI suggestions:", error);
        } finally {
            setLoadingAIRisk(false); // Hide loading indicator
            ////console.log("loadingAI set to false");
            ////console.log("AI CONTROLS: ", controls);
        }
        
    }

    const updateActionServerData = async (data, action_id) => {

        //console.log("ACTION DATA BEFORE ADJUSTMENT", data);

        // Clone data to avoid modifying state directly
        console.log("Action:", data, "action_id:", action_id)
        const updatedData = { ...data };

        // Add one day to StartDate and EndDate if they exist
        if (updatedData.StartDate) {
            const startDate = new Date(updatedData.StartDate);
            startDate.setDate(startDate.getDate() + 1);
            updatedData.StartDate = startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        }

        if (updatedData.EndDate) {
            const endDate = new Date(updatedData.EndDate);
            endDate.setDate(endDate.getDate() + 1);
            updatedData.EndDate = endDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        }

        //console.log("ACTION DATA AFTER ADJUSTMENT", updatedData);

        setLoading(true);
        editActionFN(risk_id, action_id, updatedData);
        setLoading(false);
    }
    useEffect(() => {
        if (activeriskforworkflow) {
            setRiskId(activeriskforworkflow);
            setIsPopupOpen(true);
            setActiveRiskForWorkflow(null);
        }
    }, [activeriskforworkflow]);

    //console.log("risk_id in risk overlay", risk_id);
    return token && !activeDepartmentId ? (
        <div className="flex flex-col w-full h-screen overflow-hidden">
            <TopBar className="fixed top-0 left-0 right-0 z-10" />
            <div className="flex flex-row w-full h-full overflow-hidden"> {/* Prevent horizontal scrolling */}
                <Sidebar className="fixed top-0 left-0 h-full pt-[64px] z-0" /> {/* Adjust the top to match TopBar height */}
                <div className="flex flex-col w-full p-4 overflow-auto"> {/* Adjust the margin-left to match Sidebar width */}
                    <div className="flex flex-row items-center gap-3">
                        {profile.role !== "Auditor" && (
                            <button
                                className="flex items-center justify-center gap-2 pt-2 pb-2 h-10 text-l bg-[#F8F8F8] text-black transition duration-200 rounded-[5px] px-5 hover:bg-opacity-70 shadow-md hover:shadow-lg hover:bg-[#F0F0F2]"
                                onClick={() => {
                                    if (profile && profile.role === "Admin") {
                                        createRiskFN(currentPage, pageSize, null, sortBy);
                                    } else {
                                        createRiskFN(currentPage, pageSize, profile.department_id, sortBy);
                                    }
                                }}
                                disabled={loading}
                            >
                                <LuPlus className="ml-[-10px] w-5 h-5" />
                                {loading ? <img src={LOADER} alt="Loading..." className="w-5 h-5 mx-auto" /> : "Risk"}
                            </button>
                        )}

                        {/* Ask Rabo (AI Suggestions) */}
                        

                        {error && (
                            <div className="text-red-500 text-center ml-2 mt-2 italic">{error}</div>
                        )}
                    </div>
                    <div className="h-full w-full mt-4 mb-4 tabella" style={{ overflowY: 'auto', overflowX: 'hidden' }}> {/* Prevent horizontal scrolling */}
                       {<RiskTable ref={dropRef} data={data} getRisksFN={getRisksFN} totalPagesServer={totalPages} currentPage2={currentPage} pageSize2={pageSize} reduxSortBy={sortBy} department={selectedDepartment} />}
                        <div style={{ height: "20px" }}></div>
                    </div>
                </div>
            </div>

            <Popup
                open={isPopupOpen}
                nested
                key={risk_id || 'new'}
                //contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '810px', marginTop: '14vh' }}
                contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh' }}
            >   
                {risk_id && (
                <RiskDetailsForm  key={risk_id || 'new'} close={closeCreation} openIncident={() => setIsIncidentOpen(true)} openControl={() => setIsControlOpen(true)}  setControlId={setControlId} controlopen={isControlOpen} openAction={() => setIsActionOpen(true)} setActionId={setActionId} actionopen={isActionOpen} fetchAISuggestions={fetchAISuggestions} loadingAI={loadingAI} />
                )}
            </Popup>

            {/* Floating AI Suggested Controls */}
            {/*controls?.length > 0 && (
                <div
                    className={`absolute right-6 top-28 w-[340px] bg-transparent rounded-md p-4 transition-all duration-500 ease-in-out 
                        ${showControls ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
                >
                    {controls.map((control, index) => (
                        <div
                            key={index}
                            className="control-card shadow p-3 mb-2 rounded bg-white bg-opacity-70 backdrop-blur-md border border-gray-300 transition-transform duration-300 ease-in-out"
                            style={{
                                transform: `translateY(${index * 10}px)`, // Slight stagger effect
                            }}
                        >
                            <h4 className="font-bold">{control.title}</h4>
                            <p>Type: {control.type}</p>
                            <p>{control.description}</p>
                        </div>
                    ))}
                </div>
            )*/}

            <DndProvider backend={HTML5Backend}>

            <Popup
                open={isPopupOpen}
                lockScroll // Prevent scrolling the background
                modal // Ensures popup acts as a modal
                closeOnDocumentClick={false} // Prevents closing when clicking inside
                contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh', zIndex: 1040, position: 'relative' }}
                key={risk_id || 'new'}
            >   
                 {risk_id && (
                <RiskDetailsForm  key={risk_id || 'new'} close={closeCreation} openIncident={() => setIsIncidentOpen(true)} openControl={() => setIsControlOpen(true)}  setControlId={setControlId} controlopen={isControlOpen} openAction={() => setIsActionOpen(true)} setActionId={setActionId} actionopen={isActionOpen} fetchAISuggestions={fetchAISuggestions} loadingAI={loadingAI} controls={controls} />
                 )}
            </Popup>

            {/* Floating AI Suggested Controls */}
            {controls?.length > 0 && (
                <>
                <div
                    className={`absolute right-6 top-28 w-[340px] bg-transparent rounded-md p-4 transition-all duration-500 ease-in-out ${showControls ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                        }`}
                    style={{
                        zIndex: 1050, // Ensure it's above the overlay
                        pointerEvents: 'auto', // Allow interactions
                    }}
                    
                >
                    {controls.map((control, index) => (
                        <DraggableControlCard
                            key={control.id}
                            control={control}
                            onRemove={() => onRemoveControl(control.id)}
                        />
                    ))}
                </div>
                </>
            )}
    

        </DndProvider>
            
            
            <Popup
                open={isActionOpen}
                contentStyle={{ overflow: 'auto', maxHeight: '100vh', width: '900px', marginTop: '14vh' }}
            >
                <ActionOverlay closeAction={closeAction} risk_id={risk_id} action_id={action_id} />
            </Popup>

            {/* CONTROL POPUP (level 2) */}
            <Popup open={isControlOpen} modal nested closeOnDocumentClick={false} closeOnEscape
                contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh', zIndex: 1000 }}
                overlayStyle={{ zIndex: 999 }}
            >
                <ControlOverlay key={control_id || 'new-control'} closeControl={closeControl} risk_id={risk_id} control_id={control_id} />
            </Popup>



            <Popup
                open={isIncidentOpen}
                onClose={closeIncident}
                contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '810px', marginTop: '14vh' }}
            >
                <IncidentDetailsForm is_new = {true} closeIncident={closeIncident} risk_id={risk_id} />
            </Popup>

            <NotificationContainer />

        </div>
    ) : token && activeDepartmentId ? <div className="flex flex-col w-full h-screen overflow-hidden">
        <DndProvider backend={HTML5Backend}>
        <div className="flex flex-row w-full h-full overflow-hidden"> {/* Prevent horizontal scrolling */}
                <div className="flex flex-col w-full p-4 overflow-auto"> {/* Adjust the margin-left to match Sidebar width */}
                    <div className="flex items-center gap-3">
                        {profile.role !== "Auditor" && (
                            <button
                                type="button"
                                className="flex items-center justify-center gap-2 pt-2 pb-2 h-10 text-l bg-[#F8F8F8] text-black transition duration-200 rounded-[5px] px-5 hover:bg-opacity-70 shadow-md hover:shadow-lg hover:bg-[#F0F0F2]"
                                onClick={() => {
                                    if (profile && profile.role === "Admin") {
                                        createRiskFN(currentPage, pageSize, activeDepartmentId, sortBy);
                                    } else {
                                        createRiskFN(currentPage, pageSize, profile.department_id, sortBy);
                                    }
                                }}
                                disabled={loading}
                            >
                                <LuPlus className="ml-[-10px] w-5 h-5" />
                                {loading ? (
                                    <img src={LOADER} alt="Loading..." className="w-5 h-5 mx-auto" />
                                ) : (
                                    "Risk"
                                )}
                            </button>
                        )}

                            {/* Ask Rabo (AI Suggestions) */}
                            <button
                                type="button"
                                onClick={handleAISuggestions}
                                disabled={loadingAIRisk}
                                className={`flex items-center justify-center gap-2 h-10 px-5 border rounded-[5px] shadow-md transition duration-300
                                 ${loadingAIRisk
                                        ? "bg-gradient-to-r from-[#F8F8F8] to-[#E0E0E0] animate-pulse brightness-110"
                                        : "bg-white hover:shadow-lg hover:bg-[#F0F0F2]"
                                    }`}
                            >
                                <BsStars
                                    size={16}
                                    className={`${loadingAIRisk ? "text-[#0E4A62] animate-pulse" : "text-black"}`}
                                />
                            </button>
                        {error && (
                            <div className="text-red-500 text-center ml-2 mt-2 italic">{error}</div>
                        )}
                    </div>
                <div className="h-full w-full mt-4 mb-4 overflow-hidden" ref={dropRef}> {/* Prevent horizontal scrolling */}
                   { <RiskTable ref={dropRef} data={data} getRisksFN={getRisksFN} totalPagesServer={totalPages} currentPage2={currentPage} pageSize2={pageSize} reduxSortBy={sortBy} department={selectedDepartment}/>}
                    <div style={{ height: "80px" }}></div>
                </div>
            </div>
        </div>

        {/* <Popup
            open={isPopupOpen}
            onClose={closeCreation}
            nested
            //contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '810px', marginTop: '14vh' }}
            contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh' }}
        >


        </Popup>
            <RiskDetailsForm close={closeCreation} openIncident={() => setIsIncidentOpen(true)} risk_id={risk_id} />
        </Popup> */}

        

            <Popup
                open={isPopupOpen}
                lockScroll // Prevent scrolling the background
                modal // Ensures popup acts as a modal
                closeOnDocumentClick={false} // Prevents closing when clicking inside
                contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh', zIndex: 1040, position: 'relative' }}
                key={risk_id || 'new'}
            >   
                 {risk_id && (
                <RiskDetailsForm  key={risk_id || 'new'} close={closeCreation} openIncident={() => setIsIncidentOpen(true)} openControl={() => setIsControlOpen(true)}  setControlId={setControlId} controlopen={isControlOpen} openAction={() => setIsActionOpen(true)} setActionId={setActionId} actionopen={isActionOpen} fetchAISuggestions={fetchAISuggestions} loadingAI={loadingAI} controls={controls} />
                 )}
            </Popup>

            {/* Floating AI Suggested Controls */}
            {controls?.length > 0 && (
                <>
                <div
                    className={`absolute right-6 top-28 w-[340px] bg-transparent rounded-md p-4 transition-all duration-500 ease-in-out ${showControls ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                        }`}
                    style={{
                        zIndex: 1050, // Ensure it's above the overlay
                        pointerEvents: 'auto', // Allow interactions
                    }}
                    
                >
                    {controls.map((control, index) => (
                        <DraggableControlCard
                            key={control.id}
                            control={control}
                            onRemove={() => onRemoveControl(control.id)}
                        />
                    ))}
                </div>
                </>
            )}

            </DndProvider>
            {AIRisks?.length > 0 && (
                <>
                    <div
                        className={`absolute right-6 top-28 w-[340px] bg-transparent rounded-md p-4 transition-all duration-500 ease-in-out ${showRisks ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                            }`}
                        style={{
                            zIndex: 1050, // Ensure it's above the overlay
                            pointerEvents: 'auto', // Allow interactions
                        }}

                    >
                        {AIRisks.map((risk, index) => (
                            <DraggableRiskCard
                                key={risk.id}
                                control={risk}                 // keep as control (matches your component)
                                index={index}                  // you use index inside the card
                                onRemove={() => onRemoveRisk(risk.id)}
                            />
                        ))}
                    </div>
                </>
            )}

        <Popup
            open={isActionOpen}
            contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh' }}
        >
            <ActionOverlay closeAction={closeAction} risk_id={risk_id} action_id={action_id} />
        </Popup>

        <Popup
            open={isControlOpen}
            contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh' }}
        >
            <ControlOverlay key={control_id || 'new-control'} closeControl={closeControl} risk_id={risk_id} control_id={control_id} />
        </Popup>





        <Popup
            open={isIncidentOpen}
            onClose={closeIncident}
            contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '810px', marginTop: '14vh' }}
        >
            <IncidentDetailsForm is_new = {true} closeIncident={closeIncident} risk_id={risk_id} />
        </Popup>

        <NotificationContainer />

    </div> : <Redirect to="/login" />;

}

const mapStateToProps = (state) => {
    console.log("Risks", state)
    return {

        token: state.auth.token,
        error: state.risk.error,
        risks: state.risk.risks,
        totalPages: Math.ceil(state.risk.risks?.length/state.risk.pageSize),
        //totalPages: state.risk.totalPages,
        currentPage: state.risk.currentPage,
        pageSize: state.risk.pageSize,
        isOverlayOpen: state.risk.isOverlayOpen,
        gotoIncident: state.incident.gotoIncident,
        go_to_risk_dashboard: state.risk.go_to_risk_dashboard,
        go_to_bowtie: state.risk.go_to_bowtie,
        departments: state.department.departments,
        sortBy: state.risk.sortBy,
        sorted_triggered: state.risk.sorted_triggered,
        newlycreatedRiskId: state.risk.newlycreatedRiskId,
        profile: state.profile.profile,
        changed_page_size: state.risk.changed_page_size,
        id: state.risk.id,
        departmentID: state.department.activeDepartmentId,
        //activeDepartmentId: state.department.activeDepartmentId,
        departmentDef: state.department.departments?.find(d => Number(d.department_id) === Number(state.department.activeDepartmentId))?.definition,
        departmentName: state.department.departments?.find(d => Number(d.department_id) === Number(state.department.activeDepartmentId))?.name

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createRiskFN: (currentPage, pageSize, department_id, sortBy) => dispatch(createRisk(currentPage, pageSize, department_id, sortBy)),
        resetErrorFN: () => dispatch(resetError()),
        //getRisksFN: (currentPage, pageSize, department_id, sortBy) => dispatch(getRisks(currentPage, pageSize, department_id, sortBy)),
        getRisksFN: (currentPage, pageSize, department_id, sortBy) => dispatch(getRisks(1, 100, department_id, sortBy)),
        openOverlayFN: (id) => dispatch(openOverlay(id)),
        closeOverlayFN: () => dispatch(closeOverlay()),
        getDepartmentsFN: () => dispatch(getDepartments()),
        resetSortedTriggeredFN: () => dispatch(resetSortedTriggered()),
        resetNewlycreatedRiskIdFN: () => dispatch(resetNewlycreatedRiskId()),
        resetAllTableDefinitionsFN: () => dispatch(resetAllTableDefinitions()),
        setCurrentPageReduxFN: (a) => dispatch(setCurrentPageRedux(a)),
        resetChangedPageSizeFN: () => dispatch(resetChangedPageSize()),
        setPageSizeReduxFN: (a) => dispatch(setPageSizeRedux(a)),
        editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),
        editControlFN: (risk_id, control_id, control) => dispatch(editControl(risk_id, control_id, control)),
        editRiskFN: (risk_id, risk) => dispatch(editRisk(risk_id, risk)),
        aiRiskDropFN: (risk_data, department_id) => dispatch(aiRiskDrop(risk_data, department_id)),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Risk);
